import styled from "styled-components";

export const CategoriesWrapper = styled.section`
  background: ${({ backgroundColor }) => backgroundColor};
  padding: 40px 0 50px;
  content-visibility: ${({ contentVisibility }) => contentVisibility || ""};
`;
